<div fxLayout="row" fxLayoutAlign="space-between" flex style='bottom:200px;'>
    <div>
        <mat-icon [ngClass]='getIcon'>{{getIcon}}</mat-icon>
    </div>
    <div>
        <div class='msg'>{{data.message}}</div>
    </div>
</div>